import { Component, Input, OnInit } from '@angular/core';
import { Block, BlockStyle, InputField } from 'src/app/models/block.model';
import { AppService } from 'src/app/services/app.service';
import { BlockService } from 'src/app/services/block.service';

@Component({
  selector: 'app-form',
  templateUrl: './form.component.html',
  styleUrls: ['./form.component.scss'],
})
export class FormComponent implements OnInit {
  @Input() block: Block;
  @Input() blocks: Block[];
  @Input() style: BlockStyle;
  @Input() blockIndex: number;
  @Input() mobileView: boolean;

  inputFormInputIndex: number;
  submitBtnHover: boolean = false;

  constructor(
    private appService: AppService,
    private blockService: BlockService
  ) {}

  ngOnInit(): void {}

  selectFormElement(
    input: InputField | null,
    inputIndex: number,
    type: string
  ) {
    this.appService.setState(
      {
        ...this.appService.state,
        editor: {
          ...this.appService.state.editor,
          currentFormPanelIndex: inputIndex,
        },
      },
      false
    );
  }

  focusFormInputIn(index: number) {
    this.inputFormInputIndex = index;
  }

  focusFormInputOut() {
    this.inputFormInputIndex = -1;
  }

  getFormInputStyle(index: number, inputIndex: number) {
    return this.blockService.getFormInputStyle(
      this.blocks,
      index,
      inputIndex,
      this.inputFormInputIndex
    );
  }

  getFormCheckBoxStyle(index: number) {
    return this.blockService.getFormCheckboxStyle(this.blocks, index);
  }

  getFormSubmitButtonStyle(index: number) {
    return this.blockService.getFormSubmitButtonStyle(
      this.blocks,
      index,
      this.submitBtnHover
    );
  }

  getFormPrivacyCheckStyle(index: any) {
    return this.blockService.getFormPrivacyCheckStyle(this.blocks, index);
  }

  checkIfRequiredFieldsPresent() {
    let requiredFieldsPresent = true;
    this.block.content.inputs.forEach((input: any) => {
      if (input.required && input.value == null) {
        requiredFieldsPresent = false;
      }
    });
    return requiredFieldsPresent;
  }

  over() {
    this.submitBtnHover = true;
  }

  out() {
    this.submitBtnHover = false;
  }
}
